"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../services");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ProductMatch = function ProductMatch(_ref) {
  var handset = _ref.handset;
  var matchValue = handset.matchValue,
    matchSpecs = handset.matchSpecs;
  return matchValue && matchSpecs ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ContainerWithLabel, {
    label: "".concat(matchValue, " ").concat(_services.locale.localeString('Recommendation.MatchHeading')),
    level: 2,
    appearance: "secondary",
    paddingLevel: 3
  }, matchSpecs.map(function (spec, index) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      layout: {
        sm: [2, 10],
        md: [1, 11]
      },
      spacing: 1,
      verticalAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
      name: spec.iconName,
      size: 4
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString("Specs.".concat(spec.name)), ":", ' ', _services.locale.localeString("Specs.".concat(spec.valueText), spec.valueText))), index < matchSpecs.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null));
  }))) : null;
};
var _default = ProductMatch;
exports.default = _default;